import { Checkbox, Radio } from '@ds';
import { Case } from '@/api/apis/case';
import { CardMenu } from '../CardMenu/CardMenu';

type BaseCardActionsProps = {
  caseData: Case;
  selectType: 'single' | 'multiple';
  isCandidateCard: boolean;
  openResources?: () => void;
};

export const BaseCardActions = ({ caseData, selectType, isCandidateCard, openResources }: BaseCardActionsProps) => {
  if (!isCandidateCard) {
    return <CardMenu caseData={caseData} openResources={openResources} />;
  }

  if (selectType === 'multiple') {
    return <Checkbox classNames={{ base: 'pointer-events-none' }} value={caseData.caseId} />;
  }

  return <Radio classNames={{ wrapper: 'border-base-10', base: 'pointer-events-none' }} value={caseData.caseId} />;
};
